/* eslint-disable import/no-named-as-default */
import Link from "next/link";
import React from "react";

import OptimizedImage from "@/components/common/images/OptimizedImage";
import {
  default as tradeInImageDesktop,
  default as tradeInImageTab,
} from "@/public/assets/images/trade-in-horizontal.jpg";
import tradeInImageMobile from "@/public/assets/images/trade-in-mobile.jpg";

type ExchangeCarCardProps = { variant: "desktop" | "mobile" };

const ExchangeCarCard: React.FC<ExchangeCarCardProps> = ({ variant }) => {
  if (variant === "desktop") {
    return (
      // <div className="relative z-20 my-4 hidden w-full items-center overflow-hidden rounded-[32px] bg-success-dark py-6 md:flex">
      //   <div className="relative h-16 w-1/2">
      //     <img
      //       src="/assets/images/radial-green-circle.svg"
      //       className="absolute inset-0 -left-1/2 z-10 -translate-y-7 rotate-12 scale-[1.5] blur-[3.5px]"
      //       alt="Background"
      //     />
      //     <img
      //       src="/assets/images/trade-cars.svg"
      //       className="absolute inset-0 z-20 -translate-x-[18%] -translate-y-[35%] scale-[0.6] lg:-translate-x-[23%] lg:scale-[0.5] xl:-translate-x-[18%] xl:scale-[0.6]"
      //       alt="Trade Cars"
      //     />
      //   </div>
      //   <div className="absolute max-w-sm md:translate-x-1/2 xl:translate-x-3/4">
      //     <p className="ml-4 text-wrap font-urbanist text-[20px] font-semibold leading-[26px] text-[#fff] md:ml-8 lg:ml-12 lg:max-w-[20ch] xl:max-w-sm">
      //       Exchange your old car for a new one via trade-in
      //     </p>
      //   </div>
      //   <div className="absolute right-5">
      //     <Link href={"/"}>
      //       <Button
      //         buttonText={"Exchange your car"}
      //         bgColor="white"
      //         textColor="black"
      //         className="rounded-2xl px-4 py-3 text-center font-inter font-semibold text-success-dark transition-all duration-300 hover:cursor-pointer hover:!bg-success-dark hover:text-white"
      //       ></Button>
      //     </Link>
      //   </div>
      // </div>
      <div className="relative my-6">
        <OptimizedImage
          src={tradeInImageDesktop}
          width={100}
          height={100}
          alt="trade-in"
          className="w-full rounded-lg xl:rounded-4xl"
          loading="lazy"
        />
        <Link href={"/sell-used-car-dubai"}>
          <button className="inter absolute right-5 top-1/2 z-10 -translate-y-1/2 rounded-xl bg-white px-3 py-2 text-center text-sm font-semibold hover:bg-[#a22b29] hover:text-white 2xl:px-5 2xl:py-3 2xl:text-base">
            Start Now
          </button>
        </Link>
      </div>
    );
  }

  if (variant === "mobile") {
    return (
      // <div className="relative mt-4 overflow-hidden rounded-3xl bg-success-dark py-5 lg:hidden">
      //   <div className="mb-12 flex items-center justify-between px-5">
      //     <div className="flex w-1/2 flex-col gap-y-2 sm:pl-4">
      //       <img src="/assets/images/trade-in.svg" className="h-10 w-32 scale-105 sm:scale-[1.2]" alt="Trade In" />
      //       <p className="max-w-[10ch] font-urbanist text-xl font-semibold text-white xs:max-w-[15ch] xs:text-2xl">
      //         We cash out your old car
      //       </p>
      //     </div>
      //     <div className="mr-5 w-1/2">
      //       <img src="/assets/images/trade-cars.svg" className="scale-150 sm:scale-125" alt="Trade Cars" />
      //     </div>
      //   </div>

      //   <div className="relative z-20 mt-7 flex w-full">
      //     <button className="mx-2 flex flex-grow items-center justify-center rounded-2xl bg-[#fff] px-2 py-3 text-center font-inter font-semibold text-success-dark transition-all duration-300 hover:cursor-pointer">
      //       Show More
      //     </button>
      //   </div>
      //   <div className="relative z-10">
      //     <img
      //       src="/assets/images/radial-green-circle.svg"
      //       className="absolute inset-0 z-10 -translate-y-[26%] -rotate-45 scale-[1.05] blur-[7px] sm:-translate-y-[22%]"
      //       alt="Background"
      //     />
      //   </div>
      // </div>
      <>
        <div className="relative mb-2 mt-10 sm:hidden">
          <div className="relative h-[280px] w-full ixs:h-[320px] xs:h-[500px]">
            <OptimizedImage
              src={tradeInImageMobile}
              fill
              alt="trade-in"
              className="rounded-4xl object-contain"
              loading="lazy"
            />
          </div>
          <Link href={"/sell-used-car-dubai"}>
            <button className="absolute bottom-5 left-1/2 z-10 w-9/12 -translate-x-1/2 rounded-xl !border-2 !border-white bg-white px-4 py-3 text-center font-urbanist font-semibold hover:border-2 hover:border-white hover:bg-[#a22b29] hover:text-white">
              Sell your car
            </button>
          </Link>
        </div>
        <div className="relative my-1 hidden sm:block xl:hidden">
          <OptimizedImage
            src={tradeInImageTab}
            width={100}
            height={100}
            alt="trade-in"
            className="mt-4 w-full rounded-2xl"
            loading="lazy"
          />
          <Link href={"/sell-used-car-dubai"}>
            <button className="absolute right-6 top-1/2 z-10 -translate-y-1/2 rounded-xl !border-2 !border-white bg-white px-4 py-3 text-center font-urbanist font-semibold hover:border-2 hover:border-white hover:bg-[#a22b29] hover:text-white">
              Start Now
            </button>
          </Link>
        </div>
      </>
    );
  }

  return null;
};

export default ExchangeCarCard;
